/**
 *
 * @param {daysToAdd} - can be positive or negative
 * @param {currentDate} - date object
 * @returns the n'th date from the currentDate
 */

export default function addDaysToDate({ daysToAdd, currentDate }) {
  const date = new Date(currentDate);
  const newDate = date.setDate(date.getDate() + daysToAdd);
  return new Date(newDate);
}
